module.exports = __webpack_public_path__ + "img/apple-store.ade3c31a.svg";